import { Typography } from '@material-ui/core'
import { FC, memo } from 'react'

import { useStyles } from './styles'

type InfoProps = {
  icon: React.ReactNode
  title: string
  project: string
  state?: string
  cicle?: string
  date?: string
  phenologicalStage?: string
}

const Info: FC<InfoProps> = ({
  icon,
  title,
  project,
  state,
  cicle,
  date,
  phenologicalStage,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <header>
        {icon}
        <Typography variant='h3'>{title}</Typography>
      </header>

      <section>
        <span>
          <Typography>Projeto:</Typography>
          <Typography>{project}</Typography>
        </span>
        <span>
          <Typography>Estado:</Typography>
          <Typography>{state || '-'}</Typography>
        </span>
        <span>
          <Typography>Safra:</Typography>
          <Typography>{cicle || '-'}</Typography>
        </span>
        <span>
          <Typography>Data da análise:</Typography>
          <Typography>
            {(date &&
              new Date(date)
                .toLocaleString('pt-BR', {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })
                .replace(' ', ' às ')) ||
              '-'}
          </Typography>
        </span>
        <span>
          <Typography>Estádio fenológico:</Typography>
          <Typography>{phenologicalStage || '-'}</Typography>
        </span>
      </section>
    </div>
  )
}

export default memo(Info)
